/**
 * Defines how long do we store buffered websocket responses before feeding them to parser and thereafter to react. In milliseconds.
 */
export const bufferInterval = 100;
